<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit" ref="filter">
      <span
        slot="button"
        v-if="permission.find((a) => a.name == 'Order.Create')"
      >
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      :scroll="scroll"
      @tableChange="tableChange"
    >
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a
            :disabled="!permissionChecker('Order.Query')"
            @click="handleEdit(2, rowKey.data)"
            >详情</a
          >
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"
              >更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item
                v-if="
                  rowKey.data.status == 0 ||
                  rowKey.data.status == 3 ||
                  rowKey.data.status == 6 ||
                  rowKey.data.status == 8
                "
              >
                <a
                  :disabled="
                    !(
                      permissionChecker('Order.Submit') &&
                      (rowKey.data.status == 0 ||
                        rowKey.data.status == 3 ||
                        rowKey.data.status == 6 ||
                        rowKey.data.status == 8)
                    )
                  "
                  @click="submit(1, rowKey.data)"
                  >提交</a
                >
              </a-menu-item>
              <a-menu-item
                v-if="
                  (rowKey.data.status == 0 ||
                    rowKey.data.status == 3 ||
                    rowKey.data.status == 6 ||
                    rowKey.data.status == 8) &&
                  permission.find((a) => a.name == 'Order.Edit')
                "
              >
                <a @click="handleEdit(1, rowKey.data)">编辑</a>
              </a-menu-item>
              <a-menu-item
                v-if="
                  (rowKey.data.status == 7 || rowKey.data.status == 8) &&
                  rowKey.data.status < 9 &&
                  permissionChecker('Order.Submit')
                "
              >
                <a @click="submit(3, rowKey.data)">提交到金蝶</a>
              </a-menu-item>
              <a-menu-item
                v-if="
                  rowKey.data.status != -1 &&
                  rowKey.data.status < 9 &&
                  permissionChecker('Order.Cancel')
                "
              >
                <a @click="submit(2, rowKey.data)">取消</a>
              </a-menu-item>
              <a-menu-item
                v-if="
                  (rowKey.data.status == 0 ||
                    rowKey.data.status == -1 ||
                    rowKey.data.status == 1 ||
                    rowKey.data.status == 4) &&
                  permissionChecker('Order.Delete')
                "
              >
                <a @click="submit(5, rowKey.data)">删除</a>
              </a-menu-item>
              <a-menu-item
                v-if="
                  rowKey.data.status >= 2 &&
                  rowKey.data.status < 11 &&
                  permissionChecker('Order.UnAudit')
                "
              >
                <a @click="submit(4, rowKey.data)">反审核</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-ordermaster-add
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="addVisible = false"
        :params="params"
      ></hp-manager-page-ordermaster-add>
    </hp-manager-modal>

    <a-modal
      title="确定要取消此订单"
      v-model="visible"
      @ok="subHandle(2, qxParams)"
      :okButtonProps="{ props: { disabled: this.explain == '' } }"
    >
      <div>
        <a-input placeholder="请输入取消原因" v-model="explain" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageOrdermasterAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageOrdermasterAdd,
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "orderNo",
          name: "订单号",
        },
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: [],
        },
        {
          type: "input",
          key: "dealerName",
          name: "经销商",
        },
        {
          type: "select",
          key: "orderType",
          name: "订单类型",
          options: [
            { name: "标准订单", val: 0 },
            { name: "定制订单", val: 1 },
            { name: "促销订单", val: 2 },
          ],
        },
        {
          type: "dateFilter",
          key: "effective",
          name: "下单时间",
        },
        {
          type: "select",
          key: "status",
          name: "状态",
          options: [
            { name: "取消", val: -1 },
            { name: "初始", val: 0 },
            { name: "待分公司审核", val: 1 },
            { name: "分公司审核不通过", val: 3 },
            { name: "待总部审核", val: 4 },
            { name: "总部审核不通过", val: 6 },
            { name: "待提交ERP", val: 7 },
            { name: "ERP验证失败", val: 8 },
            { name: "已提交ERP", val: 9 },
            { name: "待出库", val: 10 },
            { name: "部分出库", val: 11 },
            { name: "完成", val: 12 },
          ],
        },
        {
          type: "cascader",
          key: "groupId",
          name: "客户分组",
          options: [],
        },
        {
          type: "cascader",
          key: "departmentId",
          name: "部门",
          options: [],
        },
        {
          type: "input",
          key: "departmentName",
          name: "部门名",
        },
      ],
      scroll: { x: 1900 },
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" },
          fixed: true,
        },
        {
          title: "订单类型",
          width: 110,
          dataIndex: "orderType",
          sorter: true,
          customRender: (text, row, index) => {
            return row.orderTypeStr;
          },
        },
        {
          title: "订单号",
          width: 120,
          dataIndex: "orderNo",
          sorter: true,
        },
        {
          title: "状态",
          width: 160,
          dataIndex: "status",
          customRender: (text, row, index) => {
            return row.statusStr;
          },
        },
        {
          title: "取消人",
          width: 120,
          dataIndex: "cancelUserName",
        },
        {
          title: "订单取消时间",
          width: 160,
          dataIndex: "cancelTime",
          customRender: (text, row, index) => {
            return this.formatDate(row.cancelTime, "YYYY-MM-DD HH:mm:ss");
          },
        },
        // {
        //   title: "金蝶单号",
        //   width: 120,
        //   dataIndex: "erpOrderNo",
        //   sorter: true
        // },
        {
          title: "销售组织",
          width: 160,
          dataIndex: "organizationName",
        },
        {
          title: "部门",
          width: 140,
          dataIndex: "departmentName",
        },
        {
          title: "经销商",
          width: 200,
          dataIndex: "dealerName",
        },
        {
          title: "订单金额",
          width: 120,
          dataIndex: "totalOrderAmount",
        },
        {
          title: "发货方式",
          width: 120,
          dataIndex: "deliveryMethod",
          customRender: (text, row, index) => {
            return row.deliveryMethodStr;
          },
        },
        {
          title: "货运部",
          width: 120,
          dataIndex: "freightName",
        },
        {
          title: "下单时间",
          width: 160,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          },
        },
        {
          title: "创建人",
          width: 120,
          dataIndex: "creatorUserName",
        },
        {
          title: "订单来源",
          width: 90,
          dataIndex: "orderSource",
          customRender: (text, row, index) => {
            return row.orderSourceStr;
          },
        },
        {
          title: "修改时间",
          width: 160,
          dataIndex: "lastModificationTime",
          customRender: (text, row, index) => {
            return this.formatDate(
              row.lastModificationTime,
              "YYYY-MM-DD HH:mm:ss"
            );
          },
        },
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      qxParams: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      childWidth: "0px",
      childHeight: "0px",
      explain: "",
      visible: false,
      permission: [],
      title: "",
      allGroups: [],
      allDepartments: [],
    };
  },
  async mounted() {
    this.scroll.x = 0;
    this.columns.forEach((a) => {
      this.scroll.x = a.width + this.scroll.x;
    });
    this.GetOrganizationOptions();
    this.getAllGroups();
    this.getAllDepartment();
    this.permission = this.getPermission("Order");
    //console.log(this.$route);
    this.filterdata = Object.assign(this.filterdata, this.$route.query);
    this.getDatas(this.filterdata);
  },
  methods: {
    async GetOrganizationOptions() {
      let org = await api.GetOrganizationSelect();
      if (org) {
        let organizationOptions = [];
        org.forEach((a) => {
          organizationOptions.push({
            name: a.text,
            val: a.value,
          });
        });
        this.filter.filter((a) => a.key == "organizationId")[0].options =
          organizationOptions;
      }
    },

    async getAllGroups() {
      let groupList = await api.GetAllDealerGroups();
      if (groupList) {
        this.allGroups = groupList;
      }
      this.filter.filter((a) => a.key == "groupId")[0].options = groupList;
    },
    async getAllDepartment() {
      let departmentList = await api.GetAllDepartmentData();
      if (departmentList) {
        this.allDepartments = departmentList;
      }
      this.filter.filter((a) => a.key == "departmentId")[0].options =
        departmentList;
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.orderNo = p.values.orderNo;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.orderType = p.values.orderType;
      this.filterdata.departmentName = p.values.departmentName;
      //this.filterdata.dealerGroup=p.values.dealerGroup;
      console.log(p.values.groupId);
      this.filterdata.departmentId =
        p.values.departmentId != null && p.values.departmentId.length > 1
          ? p.values.departmentId[1] != null
            ? p.values.departmentId[1]
            : null
          : null;
      if (p.values.groupId != null && p.values.groupId.length >= 1) {
        if (p.values.groupId[2] != null) {
          this.filterdata.groupId = p.values.groupId[2];
        } else if (p.values.groupId[1] != null) {
          this.filterdata.groupId = p.values.groupId[1];
        } else {
          this.filterdata.groupId =
            p.values.groupId[0] != null ? p.values.groupId[0] : null;
        }
      } else {
        this.filterdata.groupId = null;
      }
      // this.filterdata.groupId=p.values.groupId!=null&&p.values.groupId.length>1?(
      // p.values.groupId[2]!=null?
      // p.values.groupId[2]:p.values.groupId[1]!=null?
      // p.values.groupId[1]:p.values.groupId[0]!=null?
      // p.values.groupId[0]:null):null;
      this.filterdata.status = p.values.status;
      this.filterdata.dealerName = p.values.dealerName;
      this.filterdata.startTime =
        p.values.effective[0] != null ? p.values.effective[0].valueOf() : null;
      this.filterdata.endTime =
        p.values.effective[1] != null ? p.values.effective[1].valueOf() : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑订单";
      } else if (type == 2) {
        this.title = "订单详情";
        this.isabl = true;
      } else {
        this.title = "新增订单";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    async submit(type, row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        if (type == 1 || type == 3 || type == 4) {
          this.$confirm({
            title: "确认",
            content: type == 4 ? "确定要反审核该订单?" : "确定要提交此订单?",
            onOk() {
              that.subHandle(type, row);
            },
            onCancel() {},
          });
        } else if (type == 5) {
          this.$confirm({
            title: "确认",
            content: "确定要删除此订单？",
            onOk() {
              that.subHandle(type, row);
            },
            onCancel() {},
          });
        } else {
          this.qxParams = row;
          this.visible = true;
        }
      });
    },
    async subHandle(type, row) {
      let msgRet;
      if (type == 1) {
        msgRet = await api.SubmitOrderMaster({ id: row.id });
      } else if (type == 3) {
        msgRet = await api.SubmitOrderToErp({ id: row.id });
      } else if (type == 4) {
        msgRet = await api.UnAuditOrder({ id: row.id });
      } else if (type == 5) {
        msgRet = await api.DeleteOrderMaster({ id: row.id });
      } else {
        if (this.explain == null || this.explain == "") {
          this.$message.error("请输入取消订单原因");
        } else {
          msgRet = await api.CancelOrderMaster({
            id: row.id,
            auditNotes: this.explain,
          });
        }
      }
      if (msgRet) {
        this.visible = false;
        this.qxParams = {};
        this.explain = "";
        if (type == 1 || type == 3 || type == 4) {
          this.$message.success("提交成功");
        } else if (type == 5) {
          this.$message.success("删除成功");
        } else {
          this.$message.success("取消成功");
        }
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetOrderMasterList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = (bbb) => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderMaster/List.vue